<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-4 flex-wrap">
      <h1><v-icon color="primary" large>mdi-wallet-membership</v-icon> Membresías</h1>
    </div>

    <!-- Vista Cards (móvil y tablet) -->
    <v-row v-if="!cargando">
      <v-col
        v-for="m in membresias" :key="m.id"
        cols="12" sm="6" md="4" lg="3"
      >
        <v-card rounded="xl" class="elevation-3 h-100 d-flex flex-column" style="transition:box-shadow .2s">
          <v-card-text class="pb-1 pt-4 px-4 flex-grow-1">
            <div class="d-flex align-center mb-3">
              <v-icon color="primary" large class="mr-2">mdi-wallet-membership</v-icon>
              <div>
                <div class="text-subtitle-1 font-weight-bold">{{ m.nombre }}</div>
                <div class="text-caption grey--text">{{ m.duracion }} días de duración</div>
              </div>
            </div>
            <v-chip color="primary" dark label large class="px-4 text-h6 font-weight-bold">
              {{ moneda }}{{ formatPrecio(m.precio) }}
            </v-chip>
          </v-card-text>
          <v-card-actions class="px-3 pb-3">
            <v-btn icon color="primary" @click="editar(m)" title="Editar">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon color="error" @click="eliminar(m)" title="Eliminar">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Card vacío -->
      <v-col cols="12" v-if="!membresias.length">
        <v-card rounded="xl" class="elevation-0 text-center pa-8" color="grey lighten-4">
          <v-icon size="64" color="grey lighten-1">mdi-wallet-membership</v-icon>
          <div class="text-h6 grey--text mt-2">No hay membresías registradas</div>
          <v-btn color="primary" rounded class="mt-4" @click="mostrarDialogo = true">
            <v-icon left>mdi-plus</v-icon> Agregar primera membresía
          </v-btn>
        </v-card>
      </v-col>
    </v-row>

    <!-- Skeleton mientras carga -->
    <v-row v-if="cargando">
      <v-col cols="12" sm="6" md="4" v-for="i in 3" :key="i">
        <v-skeleton-loader type="card" rounded="xl" />
      </v-col>
    </v-row>

    <!-- FAB agregar -->
    <v-btn fab dark x-large elevation="8" color="primary" fixed right bottom @click="abrirNueva">
      <v-icon dark>mdi-plus</v-icon>
    </v-btn>

    <!-- Dialog Formulario -->
    <v-dialog v-model="mostrarDialogo" persistent max-width="520px">
      <form-membresia
        @cerrado="onCerrado"
        @registrar="onRegistrar"
        :membresia="membresia"
        :titulo="titulo"
      />
    </v-dialog>

    <!-- Dialog Eliminar -->
    <v-dialog v-model="mostrarDialogoEliminar" max-width="500px">
      <dialogo-eliminar
        :nombre="itemSeleccionado"
        @cancelar="cerrarDialogoEliminar"
        @eliminar="confirmarEliminar"
      />
    </v-dialog>

    <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top>
      {{ mensaje.texto }}
    </v-snackbar>

    <v-overlay :value="cargando && membresias.length">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </div>
</template>

<script>
import FormMembresia from './FormMembresia.vue'
import DialogoEliminar from '../Dialogos/DialogoEliminar.vue'
import HttpService from '../../Servicios/HttpService'

export default {
  name: 'Membresias',
  components: { FormMembresia, DialogoEliminar },

  data: function() {
    return {
      cargando: false,
      mostrarDialogo: false,
      mostrarDialogoEliminar: false,
      membresia: { nombre: '', duracion: '', precio: '' },
      membresias: [],
      mensaje: { texto: '', color: '' },
      mostrarMensaje: false,
      titulo: 'Registrar',
      itemSeleccionado: '',
      moneda: localStorage.getItem('monedaGimnasio') || '$',
    }
  },

  mounted: function() {
    this.obtenerMembresias()
  },

  methods: {
    formatPrecio: function(p) {
      var n = parseFloat(p)
      if (isNaN(n)) return '0.00'
      return n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    abrirNueva: function() {
      this.titulo = 'Registrar'
      this.membresia = { nombre: '', duracion: '', precio: '' }
      this.mostrarDialogo = true
    },

    editar: function(membresia) {
      this.titulo = 'Editar'
      this.membresia = Object.assign({}, membresia)
      this.mostrarDialogo = true
    },

    eliminar: function(membresia) {
      this.itemSeleccionado = membresia.nombre
      this.membresia = membresia
      this.mostrarDialogoEliminar = true
    },

    cerrarDialogoEliminar: function() {
      this.mostrarDialogoEliminar = false
      this.membresia = { nombre: '', duracion: '', precio: '' }
    },

    confirmarEliminar: function() {
      var self = this
      this.cargando = true
      HttpService.eliminar('membresias.php', { metodo: 'delete', id: this.membresia.id })
      .then(function(eliminado) {
        if (eliminado) {
          self.mostrarDialogoEliminar = false
          self.mensaje = { texto: 'Membresía eliminada', color: 'success' }
          self.mostrarMensaje = true
          self.cargando = false
          self.obtenerMembresias()
        }
      })
    },

    onCerrado: function() {
      this.membresia = { nombre: '', duracion: '', precio: '' }
      this.mostrarDialogo = false
      this.titulo = 'Registrar'
    },

    onRegistrar: function(membresia) {
      var self = this
      var metodo = (this.titulo === 'Registrar') ? 'post' : 'put'
      this.cargando = true
      HttpService.registrar({ metodo: metodo, membresia: membresia }, 'membresias.php')
      .then(function(respuesta) {
        if (respuesta) {
          self.membresia = { nombre: '', duracion: '', precio: '' }
          self.mostrarDialogo = false
          self.mensaje = {
            texto: self.titulo === 'Registrar' ? 'Membresía creada' : 'Membresía actualizada',
            color: 'success'
          }
          self.mostrarMensaje = true
          self.cargando = false
          self.obtenerMembresias()
          self.titulo = 'Registrar'
        }
      })
    },

    obtenerMembresias: function() {
      var self = this
      this.cargando = true
      HttpService.obtenerConDatos({ metodo: 'get' }, 'membresias.php')
      .then(function(respuesta) {
        self.membresias = respuesta || []
        self.cargando = false
      })
    },
  },
}
</script>

<style scoped>
.h-100 { height: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/Membresias/Membresias.vue